import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { SidebarData } from "../../data/json/sidebarData";
import ImageWithBasePath from "../imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu, setMobileSidebar } from "../../data/redux/sidebarSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAllMode,
  setDataLayout,
} from "../../data/redux/themeSettingSlice";
import usePreviousRoute from "./usePreviousRoute";
import { getStudentSidebar, getTeacherAdminSidebar } from "../../../apis/user.api";
import { all_routes } from "../../../feature-module/router/all_routes";
import BranchStorageDisplayCompact from "../../../feature-module/application/BranchStorageDisplayCompact";

const Sidebar = () => {
  const [sidebarData, setSidebarData] = useState<any>([]);
  const Location = useLocation();
  const user = useSelector((state: any) => state.userSlice.user);
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };
  const location = useLocation();
  const dispatch = useDispatch();
  const previousLocation = usePreviousRoute();

  useEffect(() => {
    const layoutPages = [
      "/layout-dark",
      "/layout-rtl",
      "/layout-mini",
      "/layout-box",
      "/layout-default",
    ];

    const isCurrentLayoutPage = layoutPages.some((path) =>
      location.pathname.includes(path)
    );
    const isPreviousLayoutPage =
      previousLocation &&
      layoutPages.some((path) => previousLocation.pathname.includes(path));

    if (isPreviousLayoutPage && !isCurrentLayoutPage) {
      dispatch(resetAllMode());
    }
  }, [location, previousLocation, dispatch]);

  useEffect(() => {
    console.log("Location.pathname", Location.pathname);
    dispatch(setMobileSidebar(false));
    setSubopen(localStorage.getItem("menuOpened"));
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };

  useEffect(() => {
    if (user) {
      const userType = (localStorage.getItem("role") as keyof typeof userTypeRoutes) || "admin";
      const routes = all_routes;
      const userTypeRoutes = {
        admin: routes.adminDashboard,
        teacher: routes.teacherDashboard,
        student: routes.studentDashboard,
        parent: routes.parentDashboard,
      };
      if (user.role === "student") {
        getStudentSidebar(user?.user_id, user?.role).then((res: any) => {
          const menu = res?.data.menu;
          const formattedMenu = menu.map((it: any) => {
            // Check if user is student AND fees_status is not "Paid" and redirect to due-fees
            const shouldRedirectToDueFees = user?.role === "student" && user?.fees_status !== "Paid" && it.url !== "#" && it.url.replace(/\.php$/, "") !== "due-fees";
            const originalLink = it.url !== "#" ? (it.url.replace(/\.php$/, "") === "index" ? userTypeRoutes[userType as keyof typeof userTypeRoutes] : it.url.replace(/\.php$/, "")) : undefined;

            return {
              submenuOpen: true,
              showSubRoute: true,
              submenu: it.sub_menu && it.sub_menu.length > 0,
              label: it.title,
              icon: `ti ${it.icon}` || "",
              link: shouldRedirectToDueFees ? "/due-fees" : originalLink,
              originalLink: originalLink, // Store original link for highlighting purposes
              submenuItems: it.sub_menu.map((item: any) => {
                const shouldRedirectSubToDueFees = user?.role === "student" && user?.fees_status !== "Paid" && item.url !== "#" && item.url.replace(/\.php$/, "") !== "due-fees";
                const originalSubLink = item.url !== "#" ? item.url.replace(/\.php$/, "") : undefined;

                return {
                  label: item.title,
                  // submenu: item.sub_menu && item.sub_menu.length > 0,
                  showSubRoute: false,
                  link: shouldRedirectSubToDueFees ? "/due-fees" : originalSubLink,
                  originalLink: originalSubLink, // Store original link for highlighting purposes
                  // submenuItems: item.sub_menu?.map((sub: any) => ({
                  //   label: sub.title,
                  //   link: sub.url,
                  //   showSubRoute: false
                  // })) || []
                }
              })
            };
          })
          setSidebarData([{
            label: "MAIN MENU",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Main",
            submenuItems: formattedMenu
          }]);
        })
      } else {
        getTeacherAdminSidebar(user?.branch_id, user?.role).then((res: any) => {
          const menu = res?.menu;
          const formattedMenu = menu.map((it: any) => {
            return {
              submenuOpen: true,
              showSubRoute: true,
              submenu: it.sub_menu && it.sub_menu.length > 0,
              label: it.title,
              icon: `ti ${it.icon}` || "",
              link: it.url !== "#" ? it.url.replace(/\.php$/, "") === "/dashboard" ? userTypeRoutes[userType as keyof typeof userTypeRoutes] : it.url.replace(/\.php$/, "") : undefined,
              submenuItems: it.sub_menu.map((item: any) => ({
                label: item.title,
                // submenu: item.sub_menu && item.sub_menu.length > 0,
                showSubRoute: false,
                link: item.url !== "#" ? item.url.replace(/\.php$/, "") : undefined,
                // submenuItems: item.sub_menu?.map((sub: any) => ({
                //   label: sub.title,
                //   link: sub.url,
                //   showSubRoute: false
                // })) || []
              }))
            };
          })
          setSidebarData([{
            label: "MAIN MENU",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Main",
            submenuItems: formattedMenu
          }]);
        })
      }

    }
  }, [user]);
  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li>
                  <Link
                    to="#"
                    className="d-flex align-items-center border bg-white rounded p-2 mb-2"
                  >
                    <span className="text-dark ms-2 fw-normal">
                      {user?.branch_name ?? ""}
                    </span>
                  </Link>
                  {/* Only show storage for admin users */}
                  {user?.role === "admin" && (
                    <div className="px-2">
                      <BranchStorageDisplayCompact />
                    </div>
                  )}
                </li>
              </ul>

              <ul>
                {sidebarData?.map((mainLabel: { label: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; submenuItems: any[]; }, index: React.Key | null | undefined) => (
                  <li key={index}>
                    <h6 className="submenu-hdr">
                      <span>{mainLabel?.label}</span>
                    </h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title: any, i) => {
                        let link_array: any = [];
                        if ("submenuItems" in title) {
                          title.submenuItems?.forEach((link: any) => {
                            // Use originalLink for highlighting, fallback to link if originalLink doesn't exist
                            link_array.push(link?.originalLink || link?.link);
                            if (link?.submenu && "submenuItems" in link) {
                              link.submenuItems?.forEach((item: any) => {
                                link_array.push(item?.originalLink || item?.link);
                              });
                            }
                          });
                        }
                        title.links = link_array;

                        return (
                          <li className="submenu" key={title.label}>
                            <Link
                              to={title?.submenu ? "#" : title?.link}
                              onClick={() =>
                                handleClick(
                                  title?.label,
                                  title?.themeSetting,
                                  getLayoutClass(title?.label)
                                )
                              }
                              className={`${subOpen === title?.label ? "subdrop" : ""
                                } ${title?.links?.includes(Location.pathname)
                                  ? "active"
                                  : ""
                                } ${title?.submenuItems
                                  ?.map((link: any) => link?.originalLink || link?.link)
                                  .includes(Location.pathname) ||
                                  (title?.originalLink || title?.link) === Location.pathname
                                  ? "active"
                                  : "" || title?.subLink1 === Location.pathname
                                    ? "active"
                                    : "" || title?.subLink2 === Location.pathname
                                      ? "active"
                                      : "" || title?.subLink3 === Location.pathname
                                        ? "active"
                                        : "" || title?.subLink4 === Location.pathname
                                          ? "active"
                                          : "" || title?.subLink5 === Location.pathname
                                            ? "active"
                                            : "" || title?.subLink6 === Location.pathname
                                              ? "active"
                                              : "" || title?.subLink7 === Location.pathname
                                                ? "active"
                                                : ""
                                }`}
                            >
                              <i className={title.icon}></i>
                              <span>{title?.label}</span>
                              <span className="badge badge-primary badge-xs text-white fs-10 ms-auto">
                                {title?.version}
                              </span>
                              <span
                                className={title?.submenu ? "menu-arrow" : ""}
                              />
                            </Link>
                            {title?.submenu !== false &&
                              subOpen === title?.label && (
                                <ul
                                  style={{
                                    display:
                                      subOpen === title?.label
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {title?.submenuItems?.map((item: any) => (
                                    <li
                                      className={
                                        item?.submenuItems
                                          ? "submenu submenu-two "
                                          : ""
                                      }
                                      key={item.label}
                                    >
                                      <Link
                                        to={item?.link}
                                        className={`${item?.submenuItems
                                          ?.map((link: any) => link?.originalLink || link?.link)
                                          .includes(Location.pathname) ||
                                          (item?.originalLink || item?.link) === Location.pathname
                                          ? "active"
                                          : "" ||
                                            item?.subLink1 ===
                                            Location.pathname
                                            ? "active"
                                            : "" ||
                                              item?.subLink2 ===
                                              Location.pathname
                                              ? "active"
                                              : "" ||
                                                item?.subLink3 ===
                                                Location.pathname
                                                ? "active"
                                                : "" ||
                                                  item?.subLink4 ===
                                                  Location.pathname
                                                  ? "active"
                                                  : "" ||
                                                    item?.subLink5 ===
                                                    Location.pathname
                                                    ? "active"
                                                    : "" ||
                                                      item?.subLink6 ===
                                                      Location.pathname
                                                      ? "active"
                                                      : ""
                                          } ${subsidebar === item?.label
                                            ? "subdrop"
                                            : ""
                                          }  `}
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      {item?.submenuItems ? (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === item?.label
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {item?.submenuItems?.map(
                                            (items: any) => (
                                              <li key={items.label}>
                                                <Link
                                                  to={items?.link}
                                                  className={`${subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                    } ${items?.submenuItems
                                                      ?.map(
                                                        (link: any) => link?.originalLink || link.link
                                                      )
                                                      .includes(
                                                        Location.pathname
                                                      ) ||
                                                      (items?.originalLink || items?.link) ===
                                                      Location.pathname
                                                      ? "active"
                                                      : ""
                                                    }`}
                                                >
                                                  {items?.label}
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      ) : (
                                        <></>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
